import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, useTheme } from "@mui/material";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useTranslation } from "react-i18next";

const icons = [
  <RestaurantMenuIcon fontSize="large" color="primary" />,
  <EmojiObjectsIcon fontSize="large" color="warning" />,
  <FavoriteIcon fontSize="large" color="error" />,
];

const MealPlanLoader = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [msgIndex, setMsgIndex] = useState(0);

  const messages = [
    t("mealplan_loader_0"),
    t("mealplan_loader_1"),
    t("mealplan_loader_2"),
    t("mealplan_loader_3"),
    t("mealplan_loader_4"),
    t("mealplan_loader_5"),
    t("mealplan_loader_6"),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex((i) => (i + 1) % messages.length);
    }, 2200);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 240,
        bgcolor: theme.palette.background.paper,
        borderRadius: 3,
        boxShadow: 2,
        py: 4,
        my: 3,
      }}
    >
      <CircularProgress size={50} thickness={5} color="secondary" sx={{ mb: 2 }} />
      <Box sx={{ mb: 1 }}>{icons[msgIndex % icons.length]}</Box>
      <Typography variant="h6" align="center" sx={{ fontWeight: "bold", mb: 1 }}>
        {messages[msgIndex]}
      </Typography>
      <Typography variant="body2" align="center" color="text.secondary">
        {msgIndex === 0
          ? t("mealplan_loader_ai_planning")
          : t("mealplan_loader_almost_ready")}
      </Typography>
    </Box>
  );
};

export default MealPlanLoader;
